
import {initWebComponent} from "@/helpers/web-component-helper";

export class LayerInfoToolsMeasureTemplateComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
        <div class="row">
            <ol-draw-geometry data-draw-type="measure" data-icon="fa fa-draw-polygon" data-language="polygon"></ol-draw-geometry>
        </div>       
        <div class="row mt-2">
            <ol-draw-geometry data-draw-type="measure" data-icon="fa fa-slash" data-language="LineString"></ol-draw-geometry>
        </div>       
        <div class="row mt-2">
            <ol-draw-geometry data-draw-type="measure" data-icon="far fa-circle" data-language="circle"></ol-draw-geometry>
        </div>     
        <div class="row mt-2">
            <ol-draw-geometry data-draw-type="measure" data-icon="fa fa-font" data-language="text"></ol-draw-geometry>
        </div>  
        <div class="row mt-2">
            <ol-draw-geometry data-draw-type="measure" data-icon="far fa-dot-circle" data-language="point"></ol-draw-geometry>
        </div>  
        `;

        initWebComponent(this, template)
    }
}
